import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { OrderFulfillmentStatus } from '../../../../services/exports/Constants';
import { CheckCircleOutlined } from '@ant-design/icons';
import FooterWrapper from './FooterWrapper';

export default function OldOrder({ order }) {
  const { t } = useTranslation(null, { keyPrefix: 'Modals:Order:OrderDetails:Footers:OldOrder' });

  const renderStatus = () => {
    if (order.fulfillment_status === OrderFulfillmentStatus.Rejected) {
      return (
        <div className="w-full text-center text-white">
          {t('statuses.rejected', {
            reason: t(
              `rejection_reasons.${order.rejection_reason}`,
              order.rejection_reason ?? t('rejection_reasons.fully_refunded'),
            ),
          })}
        </div>
      );
    }

    return (
      <div className="text-center w-full">
        <CheckCircleOutlined className="mr-xs" />
        {t('statuses.fulfilled')}
      </div>
    );
  };

  return (
    <FooterWrapper
      className={classnames({
        '!bg-danger': order.fulfillment_status === OrderFulfillmentStatus.Rejected,
      })}
    >
      {renderStatus()}
    </FooterWrapper>
  );
}
